<template>
    <div class="product-content">

        <ul class="c-tabmenu c-tabmenu_max-200">
            <li class="c-tabmenu__item">
                <router-link :to="{name:'category', params:{category:'cd'}}" class="c-tabmenu__link">
                    <span class="c-tabmenu__text">CD</span>
                </router-link>
            </li>
            <li class="c-tabmenu__item">
                <router-link :to="{name:'category', params:{category:'bd'}}" class="c-tabmenu__link">
                    <span class="c-tabmenu__text">Blu-ray&amp;DVD</span>
                </router-link>
            </li>
        </ul>
        <transition name="product-index">
            <div class="product-index" v-if="!is_change_category">
                <div v-for="(story, index) in product_list" :key="index" class="c-thumb-index product-index__index">
                    <!-- <h3 class="product-index__category p-h-crimson-category">{{story.story}}</h3> -->
                    <thumb-index-item v-for="(item, index) in story.items" :key="index" :item="item" :link="item.url" :append_class="append_class"></thumb-index-item>
                </div>
            </div>
        </transition>

    </div>
</template>


<script>

// サムネイルリストコンポーネント
import ThumbIndexItemCompo from '../thumb-index/thumb-index-item.vue';

const default_category = 'cd';

export default {
    components: {
        'thumb-index-item': ThumbIndexItemCompo
    },
    data() {
        return {
            category: null,
            is_change_category: true,
            append_class: {
                item: 'c-thumb-index__item_4 c-thumb-index__item_2-sp',
                link: ''
            }
        };
    },
    computed: {
        product_list() {
            return this.$router.app.product_list[this.category];
        }
    },
    watch: {
        // 物語が変更されたらリストを変更する
        $route: 'change_category'
    },
    created() {
        // 物語が指定されていない場合はデフォルトを指定する
        if (!this.$route.params.category) {
            this.$router.push(`/${default_category}`);
        }
        this.change_category();
    },
    methods: {
        change_category() {
            // 物語に変更がなければ無視する
            if (this.category === this.$route.params.category) {
                return;
            }

            this.is_change_category = true;

            setTimeout(() => {
                this.category = this.$route.params.category;
                this.is_change_category = false;
            }, 400);
        }
    }
};
</script>



// WEBPACK FOOTER //
// product-content.vue?d5bd8226